import { Alert } from 'lib/alert/models';
import React, { Dispatch, SetStateAction, useContext } from 'react';

type ContextType = {
    alert: Partial<Alert>;
    setAlert: Dispatch<SetStateAction<Partial<Alert>>>;
    activeStep: number;
    setActiveStep: Dispatch<SetStateAction<number>>;
};

const initialContext: ContextType = {
    alert: {},
    setAlert: () => {},
    activeStep: 0,
    setActiveStep: () => 0,
};

export const AlertFormContext =
    React.createContext<ContextType>(initialContext);

export const useAlertForm = () => useContext(AlertFormContext);
